<template>
  <page :isModal="true" v-on:back="$router.push('/')">
    <div class="rank-tip">
      <span> *数据每小时更新一次 </span>
      <span> 点击箭头/左右滑动查看更多榜单 </span>
    </div>
    <div class="clock-in-rank">
      <div class="rank-list-title">
        <button class="prev" @click="prev"></button>
        {{ rankType[activeIndex].title }}榜
        <button class="next" @click="next"></button>
      </div>
      <Swipe
        class="swiper"
        @change="onChange"
        :show-indicators="false"
        :loop="false"
        ref="rankSwiper"
      >
        <SwipeItem v-for="item in rankType" :key="item.type">
          <div class="swiperInner auto">
            <div class="">
              <ul class="clockin-ranks">
                <li class="rank-item rank-title">
                  <div>排名</div>
                  <div>地区/单位</div>
                  <div>综合得分</div>
                </li>
                <template v-if="rankList.length > 0">
                  <li
                    class="rank-item"
                    v-for="(lisrItem, listIndex) in rankList"
                    :key="listIndex"
                  >
                    <div>
                      <template v-if="listIndex < 3">
                        <div
                          :class="'rank-index index' + (listIndex + 1)"
                        ></div>
                      </template>
                      <template v-else>
                        {{ listIndex + 1 }}
                      </template>
                    </div>
                    <div>
                      {{ lisrItem.name }}
                    </div>
                    <div>
                      {{ lisrItem.value.toFixed(2)}}
                    </div>
                  </li>
                </template>
                <template v-else>
                  <li class="rank-item">
                    <div></div>
                    <div>暂无数据</div>
                    <div></div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </SwipeItem>
      </Swipe>
      <!--  -->
    </div>
  </page>
</template>

<script>
import { Loading, Swipe, SwipeItem, Toast } from "vant";
import { getClockinRank } from "../../apis/index";

import page from "../../components/page";
const typeList = [
  { title: "单位分数", type: 1 },
  { title: "市州分数", type: 2 },
];
export default {
  components: {
    Swipe,
    SwipeItem,
    page,
  },
  data() {
    return {
      rankList: [],
      rankListCache: {
        rank0: [],
        rank1: [],
        rank2: [],
      },
      activeIndex: 0,
      rankType: typeList,
      swiperOptions: {},
    };
  },
  created() {
    // let _this = this;
    this.getRank(this.rankType[this.activeIndex].type,this.activeIndex);
  },
  methods: {
    prev(){
      this.$refs['rankSwiper'].prev()
    },
    next(){
      this.$refs['rankSwiper'].next()
    },
    onChange(index) {
      this.activeIndex = index;
      this.getRank(this.rankType[index].type,index);
    },
    getRank(type, index) {
      if (this.rankListCache[`rank${index}`].length > 0) {
        this.rankList = [].concat(this.rankListCache[`rank${index}`]);
        return;
      } else {
        let toast = Toast({ type: "loading" });
        this.rankList = [];
        getClockinRank({ type: type }).then((resp) => {
          toast.clear();
          // console.log(resp)
          this.rankList = resp.data || [];
          this.rankListCache[`rank${index}`] = [].concat(resp.data);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rank-tip {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  span {
    display: flex;
    align-items: flex-end;
  }
  span:nth-of-type(1) {
    font-size: 10px;
    color: #ddd;
  }
  span:nth-of-type(2) {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
  }
}
.clock-in-rank {
  padding: 20px 20px 40px;
  background-color: #fff;
  border-radius: 5px;
  .rank-list-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    position: relative;
    color: #ebd275;
    button{
      border: none;
    }
   .prev {
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      height: 30px;
      background: url("https://cbgccdn.thecover.cn/@/images/20210520/1621507460906035791.png")
        center top no-repeat;
      background-size: auto 100%;
    }
    .next {
      position: absolute;
      right: 0;
      top: 0;
      width: 30px;
      height: 30px;
      // background-color: #133415;
      background: url("https://cbgccdn.thecover.cn/@/images/20210520/1621507467735023958.png")
        center top no-repeat;
      background-size: auto 100%;
    }
  }
  .clockin-ranks {
    .rank-item {
      padding: 8px 0;
      display: flex;
      &.rank-title {
        font-size: 14px;
        color: #bbb;
      }
      border-bottom: 1px solid #eee;
      & div.rank-index {
        width: 25px;
        height: 33px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;
        &.index1 {
          background-image: url("https://cbgccdn.thecover.cn/@/images/20210521/1621562856325032132.png");
        }
        &.index2 {
          background-image: url("https://cbgccdn.thecover.cn/@/images/20210521/1621562866383089134.png");
        }
        &.index3 {
          background-image: url("https://cbgccdn.thecover.cn/@/images/20210521/1621562873989031354.png");
        }
      }

      & > div:nth-of-type(1) {
        flex: 0 0 15%;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 33px;
      }
      & > div:nth-of-type(2) {
        flex: 1 1;
        text-align: center;
        padding: 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      & > div:nth-of-type(3) {
        flex: 0 0 25%;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>